import {InjectionToken, Type} from '@angular/core';

export const twoFactorAuthComponentToken = new InjectionToken<Type<unknown>>(
  'TWO_FACTOR_AUTH_COMPONENT',
);
